import React from 'react';

function WineGlassIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M6 3V9C6 11.97 8.16 14.43 11 14.91V19H8V21H16V19H13V14.91C15.84 14.43 18 11.97 18 9V3H6ZM16 8H8V5H16V8Z'
				fill='#CF004F'
			/>
		</svg>
	);
}

export default WineGlassIcon;
